import { setupSGWTConnect } from '@sgwt/connect-core';

export const sgwtConnect = setupSGWTConnect({
  authorization_endpoint: import.meta.env.VITE_APP_SG_CONNECT_ENDPOINT,
  client_id: import.meta.env.VITE_APP_SG_CONNECT_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_APP_SG_CONNECT_REDIRECT_URI,
  scope: import.meta.env.VITE_APP_SG_CONNECT_SCOPES,
});
